module.exports = __webpack_public_path__ + "static/img/ship-bg.14180a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/supplyDetail/ship-bg.png
// module id = LAc+
// module chunks = 44